export const GETCLEARCLICKEDSTATUS = " GETCLEARCLICKEDSTATUS";
export const GETMEMBERSDATA = " GETMEMBERSDATA";
export const SUBMIT_REPORT_BASED_ON_FILTER = " SUBMIT_REPORT_BASED_ON_FILTER";
export const NO_REPORT_FOR_SELECTED_FILTERS = " NO_REPORT_FOR_SELECTED_FILTERS";
export const IS_ERROR_GENERATING_REPORT = " IS_ERROR_GENERATING_REPORT";
